export const GET_SPECTATE_LIVE_REQUEST = 'spectate/GET_SPECTATE_LIVE_REQUEST';
export const GET_SPECTATE_LIVE_SUCCESS = 'spectate/GET_SPECTATE_LIVE_SUCCESS';
export const GET_SPECTATE_LIVE_FAILURE = 'spectate/GET_SPECTATE_LIVE_FAILURE';
